import CompanyList from "./List";
import CompanyEdit from "./Edit";
export default [
    { exact: true, path: "/companies", component: CompanyList },
    { path: "/company/c", component: CompanyEdit },
    { path: "/company/e/:companyId", component: CompanyEdit }
];
